import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const CUSTOM_FONT_SIZES = [
    '13',
    '14',
    '16',
    '22',
    '26',
    '32',
    'xxs',
    'title-2xl',
    'title-2lg',
    'title-lg',
    'title-md',
    'title-md2',
    'title-sm',
    'title-xsm',
];

const twMerge = extendTailwindMerge({
    extend: {
        classGroups: {
            'font-size': [{ text: CUSTOM_FONT_SIZES }],
        },
    },
});

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}
